<template lang='pug'>
.fpui-input-text-editable(v-fp-click-outside='close')
  .editable(v-show='editable')
    fpui-input-text(
      ref='input',
      :placeholder='placeholder | translate',
      color='blue',
      :select-all-on-focus='selectAllOnFocus',
      v-model='modelTmp'
    )
    .icon-container
      i.editSave.fpui.fpui-pencil(@click='update()')
      i.editSave.fpui.fpui-remove(@click='close()')
  .not-editable.ellipsis(v-show='!editable', v-if='tooltip', @click='edit()', fpui-tooltip='model')
    | {{model||' '}}
  .not-editable(v-show='!editable', v-if='!tooltip', @click='edit()')
    span(v-if='model && format', v-html='format')
    span(v-else-if='model', v-html='model')
    span.placeholder(v-if='!model') {{placeholder}}

</template>

<script>

export default {
  props: {
    value: { required: true },
    placeholder: { type: String },
    tooltip: { type: String },
    selectAllOnFocus: { type: Boolean, default: true },
    format: { type: String },
    initialValue: { type: Function }
  },
  data () {
    return {
      modelTmp: '',
      editable: false
    }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  mounted () {
    this.$el.addEventListener('keypress', this.onKeyPress)
  },
  destroyed () {
    this.$el.removeEventListener('keypress', this.onKeyPress)
  },
  methods: {
    edit () {
      this.modelTmp = this.initialValue ? this.initialValue(this.model) : this.model
      this.editable = true
      this.$emit('open')
      if (this.$refs.input) {
        process.nextTick(() => this.$refs.input.focus())
      }
    },
    update () {
      if (!this.editable) return
      this.model = this.modelTmp
      this.editable = false
      this.$emit('close')
    },
    close () {
      this.editable = false
      this.$emit('close')
    },
    onKeyPress (e) {
      if (e.keyCode === 13) { this.update() }
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-input-text-editable {
  height: 35px;
  line-height: 35px;
  position: relative;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    white-space: nowrap;
  }

  input {
    line-height: normal;
  }
  .editable {
    width: 100%;
    border-radius: 2px;
    background: #FFF none repeat scroll 0% 0%;
    padding: 0px;
    border: 1px solid #dedede;
    font-size: 1em;
    font-weight: 300;
    letter-spacing: 1px;
    outline: none;
    .fpui-input-text {
      width: 80%;
      input {
        border: none;
      }
    }
  }
  .placeholder {
    color:#ccc;
  }
  .not-editable {
    height : 30px;
    width: 100%;
    padding:0 10px;
    cursor: pointer;
  }
  .icon-container{
    position: absolute;
    right: 0;
    top: 0;
    // width: 70px;
    cursor: pointer;
    text-align: center;
    z-index: 10;
    color: @blue;
    i {
      padding: 4px 5px 0 5px;
      // padding-top: 4px;
      display: inline-block;
      font-size: 20px;
    }
  }
}
</style>
